import ArchShape from 'assets/images/invitations/paper-shapes/arch.svg';
import DiamondShape from 'assets/images/invitations/paper-shapes/diamond.svg';
import RoundedShape from 'assets/images/invitations/paper-shapes/rounded.svg';
import ScallopedShape from 'assets/images/invitations/paper-shapes/scalloped.svg';
import SquaredShape from 'assets/images/invitations/paper-shapes/square.svg';
import TicketShape from 'assets/images/invitations/paper-shapes/ticket.svg';

export const CARD_SHAPE_FILTERS = [
  {
    value: 'square',
    label: 'Square',
    icon: SquaredShape,
  },
  {
    value: 'rounded',
    label: 'Rounded',
    icon: RoundedShape,
  },
  {
    value: 'scalloped',
    label: 'Scalloped',
    icon: ScallopedShape,
  },
  {
    value: 'arch',
    label: 'Arch',
    icon: ArchShape,
  },
  {
    value: 'ticket',
    label: 'Ticket',
    icon: TicketShape,
  },
  {
    value: 'diamond',
    label: 'Diamond',
    icon: DiamondShape,
  },
];
